import React, { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useProfile } from '../api/profiles';
import { buildProfilePath } from '../utils/profileUrl';

/**
 * Backward compatibility for legacy URLs:
 *   /user/:id  ->  /:mainSlug/:subSlug?/:subSubSlug?/:username
 */
export default function LegacyUserRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, error } = useProfile(id);

  const target = useMemo(() => {
    const profile = data?.profile;
    const categoryPath = data?.categoryPath;
    return buildProfilePath({ profile, categoryPath });
  }, [data]);

  useEffect(() => {
    if (isLoading) return;
    if (error) return;
    if (!target) return;
    // Replace to avoid polluting history with old URLs
    navigate(target, { replace: true });
  }, [isLoading, error, target, navigate]);

  // Keep UI minimal; this route is only a redirect.
  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center">
      <div className="text-secondary-600">Weiterleitung…</div>
    </div>
  );
}

